import axios from 'axios';
import React from 'react'
import { useState } from 'react';
import { Button, Form } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom'
import { isLogin, sessionId, showaccount, user } from '../../Reducer/homeReducer';
import { wishlistlength } from '../../Reducer/wishlistReducer';
import { cartlength } from '../../Reducer/cartReducer';
import { ToastContainer, toast } from 'react-toastify';
import { base_url, postHeader } from '../../Helper/request';
import Top_header from '../Header/Top_header';
import Forget from './Forget';

const LoginAction = (props) => {
    const [forgetToggle, setforgetToggle] = useState(false);
    var pathname= window.location.pathname;
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const session_id = useSelector(state => state.persistedReducer.home.session_id)
    const[loader,setloader]=useState(false);
    const [loginData, setloginData] = useState({
        email: "",
        password: ""
    });

    const [validations, setValidations] = React.useState({
        email: '',
        password: '',
    })


    const [errors, seterrors] = useState({});
    const inputHandler = (e) => {
        setloginData({
            ...loginData,
            [e.target.name]: e.target.value
        })

    }

    const validateAll = () => {
        const validations = { password: '', email: '' }
        let isValid = true

        if (!loginData.password) {
            validations.password = 'Password is required'
            isValid = false
        }

        if (loginData.password && loginData.password.length < 3) {
            validations.password = 'Password must contain min 8 characters'
            isValid = false
        }

        if (!loginData.email) {
            validations.email = 'Email is required'
            isValid = false
        }

        if (loginData.email && !/\S+@\S+\.\S+/.test(loginData.email)) {
            validations.email = 'Email format must be as example@mail.com'
            isValid = false
        }

        if (!isValid) {
            setValidations(validations)
        }

        return isValid
    }

    const validateOne = (e) => {
        const { name } = e.target;
        const value = loginData[name];
        let message = ''

        if (!value) {
            message = `${name} is required`
        }

        if (value && name === 'email' && !/\S+@\S+\.\S+/.test(value)) {
            message = 'Email format must be as example@mail.com'
        }

        setValidations({ ...validations, [name]: message })
    }
    const onLogin = (e) => {
        e.preventDefault();
        const isValid = validateAll()

        if (!isValid) {
            return false
        }

        const iData = {
            email: loginData?.email,
            password: loginData?.password,
            session_id
        }
        setloader(true);
        const options = {
            method: "POST",
            headers: postHeader
        };
        
    // window.woopra.track("sign in", {
    //     email: loginData?.email,
    //   });

        axios.post(base_url + "/user/login", iData, options).then((res) => {
            if (res?.data?.status === 1) {
                // toast.success(res?.data?.message,{
                //     autoClose: false,
                //     closeOnClick: true, 
                //   });
                const userData = {};
                userData.user_id = res?.data?.data?.user_id;
                userData.username = res?.data?.data?.username;
                userData.email = res?.data?.data?.email;
                userData.first_name = res?.data?.data?.first_name;
                userData.last_name = res?.data?.data?.last_name;
                userData.phone = res?.data?.data?.phone;
                userData.token = res?.data?.data?.token;
                dispatch(user(userData));
                dispatch(cartlength(res?.data?.data?.total_cart_count));
                dispatch(wishlistlength(res?.data?.data?.total_wish_count));
                dispatch(sessionId(""));
                dispatch(isLogin(true));
                setloader(false);
                if (window?.klaviyo) {
                    window.klaviyo.push(['identify', {
                        // Change the line below to dynamically print the user's email.
                        'email': res?.data?.data?.email,
                        'Name':  res?.data?.data?.username,
                        'Phone': res?.data?.data?.phone
                    }])
                  };
                dispatch(showaccount(false));
                if(pathname==="/cart"){
                    navigate("/cart");
                }else{
                    if(props?.page==="checkout"){
                        window.location.reload()
                    }
                    navigate("/settings");
                }

            } else {
                toast.error(
                    <div dangerouslySetInnerHTML={{ __html: res?.data?.message }} />
                  );
                setloader(false);
            }
        });
    }


    return (
        <>
            <ToastContainer />
            {
                    props?.page==="checkout" ? <>
                        <Form.Group className="persone-info" >
                    <Form.Control onChange={(e) => inputHandler(e)} onBlur={validateOne} name="email" type="email" placeholder="User Name" />
                    {
                        validations?.email && <div className='validation mt-0 mb-2'>
                            {validations?.email}
                        </div>
                    }
                </Form.Group>
                <Form.Group className="persone-info">
                    <Form.Control onChange={(e) => inputHandler(e)} onBlur={validateOne} name="password" type="password" placeholder="password" />
                    {
                        validations?.password && <div className='validation mt-1'>
                            {validations?.password}
                        </div>

                        
                    }

                </Form.Group>
                <Button onClick={onLogin} className='theme_btn login_btn mb-3 mt-1' variant="primary1" type="button">{
                    loader ? "Signing In..." : "Sign in"
                } </Button>
                    </>
                    :    <Form onSubmit={onLogin}>
                    {
                            props?.page!=="checkout" && <h4 className='subtitle'>Sign in to Your Account </h4>
                        }
                        <Form.Group className="persone-info" >
                            <Form.Control onChange={(e) => inputHandler(e)} onBlur={validateOne} name="email" type="email" placeholder="User Name" />
                            {
                                validations?.email && <div className='validation mt-0 mb-2'>
                                    {validations?.email}
                                </div>
                            }
                        </Form.Group>
                        <Form.Group className="persone-info">
                            <Form.Control onChange={(e) => inputHandler(e)} onBlur={validateOne} name="password" type="password" placeholder="password" />
                            {
                                validations?.password && <div className='validation mt-1'>
                                    {validations?.password}
                                </div>
                            }
        
                        </Form.Group>
                        <Button className='theme_btn login_btn mb-3' variant="primary1" type="submit">{
                            loader ? "Signing In..." : "Sign in"
                        } </Button>
        
        
                        <Link to="#" onClick={() => setforgetToggle(!forgetToggle)} className='forgot-pass d-block'>Forgot Your Password?</Link>
                      
        
                    </Form>
                    }
         
            {
                      forgetToggle && <div className='mt-3'><Forget /></div>
                    }
        </>

    )
}

export default LoginAction